import { render, staticRenderFns } from "./payer-email.vue?vue&type=template&id=6c3aac6d"
import script from "./payer-email.vue?vue&type=script&lang=js"
export * from "./payer-email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports